import { useParams } from "react-router-dom";
import { useTenant } from "../hooks/useTenant";
import { TenantSettingsEditor } from "../components/editor/TenantSettingsEditor";
import { MinAppCodeVersionField } from "../components/editor/MinAppCodeVersionField";
import { colors, space } from "../lib/tokens";

export function TenantAppPage() {
  const { slug = "" } = useParams<{ slug: string }>();
  const { tenant, loading } = useTenant(slug);
  if (loading || !tenant) return <div style={{ color: colors.stone }}>Carregando...</div>;
  return (
    <div>
      <TenantSettingsEditor tenantId={tenant.id} section="app" />
      {/* KLUB-245 — lives in `tenants`, not `tenant_settings`: own group, own save row. */}
      <div style={{ marginTop: space.xxxl }}>
        <MinAppCodeVersionField
          key={tenant.id}
          tenantId={tenant.id}
          tenantName={tenant.name}
          initialValue={tenant.min_app_code_version}
        />
      </div>
    </div>
  );
}
